import {useGetBatch} from '@/modules/stocks/batches/api'
import {Batch, EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'
import {useGetBatchActivities} from '@/modules/stocks/batches/api/use-get-batch-activities'

interface State {
  batch: Batch
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  batch: Batch
}

const BatchContext = createContext<State>({} as State)

export function BatchProvider({children, batch: initialBatch}: Props) {
  const [batch] = useGetBatch(initialBatch.id)
  const [activities] = useGetBatchActivities(initialBatch.id)

  return <BatchContext.Provider value={{batch: batch || initialBatch, activities}}>{children}</BatchContext.Provider>
}

export function useBatchContext() {
  return useContext(BatchContext)
}
